<div class="cron-builder" [formGroup]="fg">
  <div class="row g-2">
    <div class="col-6 col-md">
      <label class="form-label">{{'labels.cron.minute'|translate}}</label>
      <select formControlName="minute" class="form-select form-select-sm">
        <option *ngFor="let o of minuteOptions" [value]="o.value">{{o.label|translate}}</option>
      </select>
    </div>
    <div class="col-6 col-md">
      <label class="form-label">{{'labels.cron.hour'|translate}}</label>
      <select formControlName="hour" class="form-select form-select-sm">
        <option *ngFor="let o of hourOptions" [value]="o.value">{{o.label|translate}}</option>
      </select>
    </div>
    <div class="col-6 col-md">
      <label class="form-label">{{'labels.cron.day_of_month'|translate}}</label>
      <select formControlName="dayOfMonth" class="form-select form-select-sm">
        <option *ngFor="let o of dayOfMonthOptions" [value]="o.value">{{o.label|translate}}</option>
      </select>
    </div>
    <div class="col-6 col-md">
      <label class="form-label">{{'labels.cron.month'|translate}}</label>
      <select formControlName="month" class="form-select form-select-sm">
        <option *ngFor="let o of monthOptions" [value]="o.value">{{o.label|translate}}</option>
      </select>
    </div>
    <div class="col-6 col-md">
      <label class="form-label">{{'labels.cron.day_of_week'|translate}}</label>
      <select formControlName="dayOfWeek" class="form-select form-select-sm">
        <option *ngFor="let o of dayOfWeekOptions" [value]="o.value">{{o.label|translate}}</option>
      </select>
    </div>
  </div>
  <div class="mt-2 d-flex align-items-center gap-3">
    <small class="text-muted font-monospace">{{ buildExpression() }}</small>
    <small class="text-primary" *ngIf="buildExpression() | describeCron as desc">→ {{desc}}</small>
  </div>
  <ng-container *ngIf="externalRuns !== null; else localRuns">
    <div class="mt-1" *ngIf="externalRuns.length">
      <small class="text-muted d-block" *ngFor="let run of externalRuns">
        <i class="bx bx-time-five me-1"></i>{{run | date: 'dd.MM.yyyy HH:mm'}}
      </small>
    </div>
  </ng-container>
  <ng-template #localRuns>
    <div class="mt-1" *ngIf="buildExpression() | nextCronRuns as runs">
      <small class="text-muted d-block" *ngFor="let run of runs">
        <i class="bx bx-time-five me-1"></i>{{run | date: 'dd.MM.yyyy HH:mm'}}
      </small>
    </div>
  </ng-template>
</div>
